import { render, staticRenderFns } from "./PreviewPartnerProfile.vue?vue&type=template&id=50c675da&scoped=true"
import script from "./PreviewPartnerProfile.vue?vue&type=script&lang=js"
export * from "./PreviewPartnerProfile.vue?vue&type=script&lang=js"
import style0 from "./PreviewPartnerProfile.vue?vue&type=style&index=0&id=50c675da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c675da",
  null
  
)

export default component.exports